import { useEffect, useState } from "react";
import { blobUrl } from "./api.ts";

/** Fetches an authorised blob (photo) as an object URL; null while loading, on error, or with no path. */
export function useBlobUrl(path: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!path) { setUrl(null); return; }
    let live = true;
    let made: string | null = null;
    blobUrl(path).then((u) => { made = u; if (live) setUrl(u); else URL.revokeObjectURL(u); }, () => live && setUrl(null));
    return () => { live = false; if (made) URL.revokeObjectURL(made); };
  }, [path]);
  return url;
}
